import { render, staticRenderFns } from "./TaxSaldoModal.vue?vue&type=template&id=2b2b6915"
import script from "./TaxSaldoModal.vue?vue&type=script&lang=js"
export * from "./TaxSaldoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports